// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { VERSION } from '../version';

export const environment = {
  production: false,
  useEmulators: false,
  // When true the app runs in read-only "store" mode (mobile builds for
  // App Store / Play Store): only visualization of areas, devices and alerts.
  storeMode: false,
  version: VERSION,
  MQTT_SERVICE_OPTIONS: {
    hostname: 'dev-vm.ethersoft.org', //'localhost' to test locally
    port: 8083, //'80' to test locally
    path: '/mqtt',
    protocol: 'wss', //'ws' to test locally
    connectOnCreate: false
  },
  // Note: All MQTT credentials are now managed server-side for enhanced security
  firebase: {
    apiKey: "AIzaSyAGRF3cVq4NO-ol5UcunoXUBGTb-WJjGg8",
    authDomain: "avalon9-dev.firebaseapp.com",
    projectId: "avalon9-dev",
    storageBucket: "avalon9-dev.appspot.com",
    messagingSenderId: "1093076708805",
    appId: "1:1093076708805:web:2b2cc0c63e4c1884a9efac"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
